// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.0
// source: roboverse_platform_protos/statekeeping/Reported/Drone/DJI/DockOSD.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire';

import { Timestamp } from '../../../../../google/protobuf/timestamp';

export const protobufPackage = 'roboverse_platform_protos.statekeeping.Reported.Drone.DJI';

export interface DockOSD {
  /** Main dock OSD data structure - from DockOsd.msg */
  timestamp: Date | undefined;
  /** Drone ROS: DockOsd.msg -> tid */
  tid: string;
  /** Drone ROS: DockOsd.msg -> bid */
  bid: string;
  /** Drone ROS: DockOsd.msg -> network_state */
  networkState: DockOSD_NetworkState | undefined;
  /** Drone ROS: DockOsd.msg -> drone_in_dock */
  droneInDock: number;
  /** Drone ROS: DockOsd.msg -> rainfall */
  rainfall: number;
  /** Drone ROS: DockOsd.msg -> environment_temperature */
  environmentTemperature: number;
  /** Drone ROS: DockOsd.msg -> longitude */
  longitude: number;
  /** Drone ROS: DockOsd.msg -> latitude */
  latitude: number;
  /** Ellipsoid height of the dock (Meters / m) */
  height: number;
  /** Drone ROS: DockOsd.msg -> heading */
  heading: number;
  /** Drone ROS: DockOsd.msg -> alternate_land_point */
  alternateLandPoint: DockOSD_AlternateLandPoint | undefined;
  /** Drone ROS: DockOsd.msg -> first_power_on */
  firstPowerOn: Date | undefined;
  /** FileStorage storage = 14;                     // Drone ROS: DockOsd.msg -> storage */
  modeCode: number;
  /** Drone ROS: DockOsd.msg -> cover_state */
  coverState: number;
  /** Drone ROS: DockOsd.msg -> supplement_light_state */
  supplementLightState: number;
  /** Drone ROS: DockOsd.msg -> emergency_stop_state */
  emergencyStopState: number;
  /** Drone ROS: DockOsd.msg -> humidity */
  humidity: number;
  /** Drone ROS: DockOsd.msg -> temperature */
  temperature: number;
  /** Drone ROS: DockOsd.msg -> wind_speed */
  windSpeed: number;
  /** Drone ROS: DockOsd.msg -> battery_store_mode */
  batteryStoreMode: number;
  /** Drone ROS: DockOsd.msg -> alarm_state */
  alarmState: number;
  /** Drone ROS: DockOsd.msg -> putter_state */
  putterState: number;
  /** Drone ROS: DockOsd.msg -> drc_state */
  drcState: number;
  /** Drone ROS: DockOsd.msg -> flighttask_prepare_capacity */
  flighttaskPrepareCapacity: number;
  /** Drone ROS: DockOsd.msg -> flighttask_step_code */
  flighttaskStepCode: number;
  /** Drone ROS: DockOsd.msg -> sub_device */
  subDevice: DockOSD_SubDevice | undefined;
  /** Drone ROS: DockOsd.msg -> user_experience_improvement */
  userExperienceImprovement: number;
  /** Drone ROS: DockOsd.msg -> job_number */
  jobNumber: number;
  /** Drone ROS: DockOsd.msg -> acc_time */
  accTime: number;
  /** Drone ROS: DockOsd.msg -> activation_time */
  activationTime: Date | undefined;
  /** Drone ROS: DockOsd.msg -> electric_supply_voltage */
  electricSupplyVoltage: number;
  /** Drone ROS: DockOsd.msg -> working_voltage */
  workingVoltage: number;
  /** Drone ROS: DockOsd.msg -> working_current */
  workingCurrent: number;
}

export interface DockOSD_NetworkState {
  type: number;
  quality: number;
  rate: number;
}

export interface DockOSD_AlternateLandPoint {
  longitude: number;
  latitude: number;
  height: number;
  safeLandHeight: number;
  /** Drone Drone ROS: AlternateLandPoint.msg -> is_configured [int32] */
  isConfigured: boolean;
}

/**
 * TODO: this data could be moved to Streaming proto maybe, but need some claryfication + Streaming has "spotServiceName" prop which should be removed/moved
 * Gateway device live streaming capability
 */
export interface DockOSD_LiveCapacity {
  /** Selectable stream count */
  availableVideoNumber: number;
  /** Max concurrent streams */
  coexistVideoNumberMax: number;
}

export interface DockOSD_DockStateData {
  firmwareVersion: string;
  firmwareUpgradeStatus: number;
  compatibleStatus: number;
  liveCapacity: DockOSD_LiveCapacity | undefined;
  accTime: number;
  wpmzVersion: string;
}

export interface DockOSD_SubDevice {
  /** Drone ROS: SubDevice.msg -> device_sn */
  deviceSn: string;
  /** Drone ROS: SubDevice.msg -> device_model_key */
  deviceModelKey: string;
  /** Drone ROS: SubDevice.msg -> device_online_status [int8] */
  deviceOnlineStatus: number;
  /** Drone ROS: SubDevice.msg -> device_paired [int8] */
  devicePaired: number;
}

export interface DockOSD_ObstacleSensing {
  /** Upward & downward obstacle distances (mm) */
  upDistance: number;
  downDistance: number;
  /** State flags */
  upEnable: boolean;
  upWork: boolean;
  downEnable: boolean;
  downWork: boolean;
  /** Left / right / front / back */
  leftEnable: boolean;
  leftWork: boolean;
  rightEnable: boolean;
  rightWork: boolean;
  frontEnable: boolean;
  frontWork: boolean;
  backEnable: boolean;
  backWork: boolean;
  /** Vertical & horizontal sensing states */
  verticalEnable: boolean;
  verticalWork: boolean;
  horizontalEnable: boolean;
  horizontalWork: boolean;
  /**
   * 360-degree obstacle distances around drone (mm)
   * Index 0 = heading direction, values go clockwise
   */
  aroundDistance: number[];
}

function createBaseDockOSD(): DockOSD {
  return {
    timestamp: undefined,
    tid: '',
    bid: '',
    networkState: undefined,
    droneInDock: 0,
    rainfall: 0,
    environmentTemperature: 0,
    longitude: 0,
    latitude: 0,
    height: 0,
    heading: 0,
    alternateLandPoint: undefined,
    firstPowerOn: undefined,
    modeCode: 0,
    coverState: 0,
    supplementLightState: 0,
    emergencyStopState: 0,
    humidity: 0,
    temperature: 0,
    windSpeed: 0,
    batteryStoreMode: 0,
    alarmState: 0,
    putterState: 0,
    drcState: 0,
    flighttaskPrepareCapacity: 0,
    flighttaskStepCode: 0,
    subDevice: undefined,
    userExperienceImprovement: 0,
    jobNumber: 0,
    accTime: 0,
    activationTime: undefined,
    electricSupplyVoltage: 0,
    workingVoltage: 0,
    workingCurrent: 0,
  };
}

export const DockOSD: MessageFns<DockOSD> = {
  encode(message: DockOSD, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(10).fork()).join();
    }
    if (message.tid !== '') {
      writer.uint32(18).string(message.tid);
    }
    if (message.bid !== '') {
      writer.uint32(26).string(message.bid);
    }
    if (message.networkState !== undefined) {
      DockOSD_NetworkState.encode(message.networkState, writer.uint32(34).fork()).join();
    }
    if (message.droneInDock !== 0) {
      writer.uint32(40).int32(message.droneInDock);
    }
    if (message.rainfall !== 0) {
      writer.uint32(48).int32(message.rainfall);
    }
    if (message.environmentTemperature !== 0) {
      writer.uint32(57).double(message.environmentTemperature);
    }
    if (message.longitude !== 0) {
      writer.uint32(65).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(73).double(message.latitude);
    }
    if (message.height !== 0) {
      writer.uint32(81).double(message.height);
    }
    if (message.heading !== 0) {
      writer.uint32(89).double(message.heading);
    }
    if (message.alternateLandPoint !== undefined) {
      DockOSD_AlternateLandPoint.encode(
        message.alternateLandPoint,
        writer.uint32(98).fork(),
      ).join();
    }
    if (message.firstPowerOn !== undefined) {
      Timestamp.encode(toTimestamp(message.firstPowerOn), writer.uint32(106).fork()).join();
    }
    if (message.modeCode !== 0) {
      writer.uint32(120).int32(message.modeCode);
    }
    if (message.coverState !== 0) {
      writer.uint32(128).int32(message.coverState);
    }
    if (message.supplementLightState !== 0) {
      writer.uint32(136).int32(message.supplementLightState);
    }
    if (message.emergencyStopState !== 0) {
      writer.uint32(144).int32(message.emergencyStopState);
    }
    if (message.humidity !== 0) {
      writer.uint32(153).double(message.humidity);
    }
    if (message.temperature !== 0) {
      writer.uint32(161).double(message.temperature);
    }
    if (message.windSpeed !== 0) {
      writer.uint32(169).double(message.windSpeed);
    }
    if (message.batteryStoreMode !== 0) {
      writer.uint32(176).int32(message.batteryStoreMode);
    }
    if (message.alarmState !== 0) {
      writer.uint32(184).int32(message.alarmState);
    }
    if (message.putterState !== 0) {
      writer.uint32(192).int32(message.putterState);
    }
    if (message.drcState !== 0) {
      writer.uint32(200).int32(message.drcState);
    }
    if (message.flighttaskPrepareCapacity !== 0) {
      writer.uint32(208).int32(message.flighttaskPrepareCapacity);
    }
    if (message.flighttaskStepCode !== 0) {
      writer.uint32(216).int32(message.flighttaskStepCode);
    }
    if (message.subDevice !== undefined) {
      DockOSD_SubDevice.encode(message.subDevice, writer.uint32(226).fork()).join();
    }
    if (message.userExperienceImprovement !== 0) {
      writer.uint32(232).int32(message.userExperienceImprovement);
    }
    if (message.jobNumber !== 0) {
      writer.uint32(240).int32(message.jobNumber);
    }
    if (message.accTime !== 0) {
      writer.uint32(248).int32(message.accTime);
    }
    if (message.activationTime !== undefined) {
      Timestamp.encode(toTimestamp(message.activationTime), writer.uint32(258).fork()).join();
    }
    if (message.electricSupplyVoltage !== 0) {
      writer.uint32(264).int32(message.electricSupplyVoltage);
    }
    if (message.workingVoltage !== 0) {
      writer.uint32(272).int32(message.workingVoltage);
    }
    if (message.workingCurrent !== 0) {
      writer.uint32(281).double(message.workingCurrent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.bid = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.networkState = DockOSD_NetworkState.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.droneInDock = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.rainfall = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.environmentTemperature = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.heading = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.alternateLandPoint = DockOSD_AlternateLandPoint.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.firstPowerOn = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.modeCode = reader.int32();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.coverState = reader.int32();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.supplementLightState = reader.int32();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.emergencyStopState = reader.int32();
          continue;
        }
        case 19: {
          if (tag !== 153) {
            break;
          }

          message.humidity = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.temperature = reader.double();
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.windSpeed = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.batteryStoreMode = reader.int32();
          continue;
        }
        case 23: {
          if (tag !== 184) {
            break;
          }

          message.alarmState = reader.int32();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.putterState = reader.int32();
          continue;
        }
        case 25: {
          if (tag !== 200) {
            break;
          }

          message.drcState = reader.int32();
          continue;
        }
        case 26: {
          if (tag !== 208) {
            break;
          }

          message.flighttaskPrepareCapacity = reader.int32();
          continue;
        }
        case 27: {
          if (tag !== 216) {
            break;
          }

          message.flighttaskStepCode = reader.int32();
          continue;
        }
        case 28: {
          if (tag !== 226) {
            break;
          }

          message.subDevice = DockOSD_SubDevice.decode(reader, reader.uint32());
          continue;
        }
        case 29: {
          if (tag !== 232) {
            break;
          }

          message.userExperienceImprovement = reader.int32();
          continue;
        }
        case 30: {
          if (tag !== 240) {
            break;
          }

          message.jobNumber = reader.int32();
          continue;
        }
        case 31: {
          if (tag !== 248) {
            break;
          }

          message.accTime = reader.int32();
          continue;
        }
        case 32: {
          if (tag !== 258) {
            break;
          }

          message.activationTime = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 33: {
          if (tag !== 264) {
            break;
          }

          message.electricSupplyVoltage = reader.int32();
          continue;
        }
        case 34: {
          if (tag !== 272) {
            break;
          }

          message.workingVoltage = reader.int32();
          continue;
        }
        case 35: {
          if (tag !== 281) {
            break;
          }

          message.workingCurrent = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD {
    return {
      timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
      tid: isSet(object.tid) ? globalThis.String(object.tid) : '',
      bid: isSet(object.bid) ? globalThis.String(object.bid) : '',
      networkState: isSet(object.networkState)
        ? DockOSD_NetworkState.fromJSON(object.networkState)
        : undefined,
      droneInDock: isSet(object.droneInDock) ? globalThis.Number(object.droneInDock) : 0,
      rainfall: isSet(object.rainfall) ? globalThis.Number(object.rainfall) : 0,
      environmentTemperature: isSet(object.environmentTemperature)
        ? globalThis.Number(object.environmentTemperature)
        : 0,
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
      alternateLandPoint: isSet(object.alternateLandPoint)
        ? DockOSD_AlternateLandPoint.fromJSON(object.alternateLandPoint)
        : undefined,
      firstPowerOn: isSet(object.firstPowerOn) ? fromJsonTimestamp(object.firstPowerOn) : undefined,
      modeCode: isSet(object.modeCode) ? globalThis.Number(object.modeCode) : 0,
      coverState: isSet(object.coverState) ? globalThis.Number(object.coverState) : 0,
      supplementLightState: isSet(object.supplementLightState)
        ? globalThis.Number(object.supplementLightState)
        : 0,
      emergencyStopState: isSet(object.emergencyStopState)
        ? globalThis.Number(object.emergencyStopState)
        : 0,
      humidity: isSet(object.humidity) ? globalThis.Number(object.humidity) : 0,
      temperature: isSet(object.temperature) ? globalThis.Number(object.temperature) : 0,
      windSpeed: isSet(object.windSpeed) ? globalThis.Number(object.windSpeed) : 0,
      batteryStoreMode: isSet(object.batteryStoreMode)
        ? globalThis.Number(object.batteryStoreMode)
        : 0,
      alarmState: isSet(object.alarmState) ? globalThis.Number(object.alarmState) : 0,
      putterState: isSet(object.putterState) ? globalThis.Number(object.putterState) : 0,
      drcState: isSet(object.drcState) ? globalThis.Number(object.drcState) : 0,
      flighttaskPrepareCapacity: isSet(object.flighttaskPrepareCapacity)
        ? globalThis.Number(object.flighttaskPrepareCapacity)
        : 0,
      flighttaskStepCode: isSet(object.flighttaskStepCode)
        ? globalThis.Number(object.flighttaskStepCode)
        : 0,
      subDevice: isSet(object.subDevice) ? DockOSD_SubDevice.fromJSON(object.subDevice) : undefined,
      userExperienceImprovement: isSet(object.userExperienceImprovement)
        ? globalThis.Number(object.userExperienceImprovement)
        : 0,
      jobNumber: isSet(object.jobNumber) ? globalThis.Number(object.jobNumber) : 0,
      accTime: isSet(object.accTime) ? globalThis.Number(object.accTime) : 0,
      activationTime: isSet(object.activationTime)
        ? fromJsonTimestamp(object.activationTime)
        : undefined,
      electricSupplyVoltage: isSet(object.electricSupplyVoltage)
        ? globalThis.Number(object.electricSupplyVoltage)
        : 0,
      workingVoltage: isSet(object.workingVoltage) ? globalThis.Number(object.workingVoltage) : 0,
      workingCurrent: isSet(object.workingCurrent) ? globalThis.Number(object.workingCurrent) : 0,
    };
  },

  toJSON(message: DockOSD): unknown {
    const obj: any = {};
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp.toISOString();
    }
    if (message.tid !== '') {
      obj.tid = message.tid;
    }
    if (message.bid !== '') {
      obj.bid = message.bid;
    }
    if (message.networkState !== undefined) {
      obj.networkState = DockOSD_NetworkState.toJSON(message.networkState);
    }
    if (message.droneInDock !== 0) {
      obj.droneInDock = Math.round(message.droneInDock);
    }
    if (message.rainfall !== 0) {
      obj.rainfall = Math.round(message.rainfall);
    }
    if (message.environmentTemperature !== 0) {
      obj.environmentTemperature = message.environmentTemperature;
    }
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    if (message.alternateLandPoint !== undefined) {
      obj.alternateLandPoint = DockOSD_AlternateLandPoint.toJSON(message.alternateLandPoint);
    }
    if (message.firstPowerOn !== undefined) {
      obj.firstPowerOn = message.firstPowerOn.toISOString();
    }
    if (message.modeCode !== 0) {
      obj.modeCode = Math.round(message.modeCode);
    }
    if (message.coverState !== 0) {
      obj.coverState = Math.round(message.coverState);
    }
    if (message.supplementLightState !== 0) {
      obj.supplementLightState = Math.round(message.supplementLightState);
    }
    if (message.emergencyStopState !== 0) {
      obj.emergencyStopState = Math.round(message.emergencyStopState);
    }
    if (message.humidity !== 0) {
      obj.humidity = message.humidity;
    }
    if (message.temperature !== 0) {
      obj.temperature = message.temperature;
    }
    if (message.windSpeed !== 0) {
      obj.windSpeed = message.windSpeed;
    }
    if (message.batteryStoreMode !== 0) {
      obj.batteryStoreMode = Math.round(message.batteryStoreMode);
    }
    if (message.alarmState !== 0) {
      obj.alarmState = Math.round(message.alarmState);
    }
    if (message.putterState !== 0) {
      obj.putterState = Math.round(message.putterState);
    }
    if (message.drcState !== 0) {
      obj.drcState = Math.round(message.drcState);
    }
    if (message.flighttaskPrepareCapacity !== 0) {
      obj.flighttaskPrepareCapacity = Math.round(message.flighttaskPrepareCapacity);
    }
    if (message.flighttaskStepCode !== 0) {
      obj.flighttaskStepCode = Math.round(message.flighttaskStepCode);
    }
    if (message.subDevice !== undefined) {
      obj.subDevice = DockOSD_SubDevice.toJSON(message.subDevice);
    }
    if (message.userExperienceImprovement !== 0) {
      obj.userExperienceImprovement = Math.round(message.userExperienceImprovement);
    }
    if (message.jobNumber !== 0) {
      obj.jobNumber = Math.round(message.jobNumber);
    }
    if (message.accTime !== 0) {
      obj.accTime = Math.round(message.accTime);
    }
    if (message.activationTime !== undefined) {
      obj.activationTime = message.activationTime.toISOString();
    }
    if (message.electricSupplyVoltage !== 0) {
      obj.electricSupplyVoltage = Math.round(message.electricSupplyVoltage);
    }
    if (message.workingVoltage !== 0) {
      obj.workingVoltage = Math.round(message.workingVoltage);
    }
    if (message.workingCurrent !== 0) {
      obj.workingCurrent = message.workingCurrent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD>, I>>(base?: I): DockOSD {
    return DockOSD.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD>, I>>(object: I): DockOSD {
    const message = createBaseDockOSD();
    message.timestamp = object.timestamp ?? undefined;
    message.tid = object.tid ?? '';
    message.bid = object.bid ?? '';
    message.networkState =
      object.networkState !== undefined && object.networkState !== null
        ? DockOSD_NetworkState.fromPartial(object.networkState)
        : undefined;
    message.droneInDock = object.droneInDock ?? 0;
    message.rainfall = object.rainfall ?? 0;
    message.environmentTemperature = object.environmentTemperature ?? 0;
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.height = object.height ?? 0;
    message.heading = object.heading ?? 0;
    message.alternateLandPoint =
      object.alternateLandPoint !== undefined && object.alternateLandPoint !== null
        ? DockOSD_AlternateLandPoint.fromPartial(object.alternateLandPoint)
        : undefined;
    message.firstPowerOn = object.firstPowerOn ?? undefined;
    message.modeCode = object.modeCode ?? 0;
    message.coverState = object.coverState ?? 0;
    message.supplementLightState = object.supplementLightState ?? 0;
    message.emergencyStopState = object.emergencyStopState ?? 0;
    message.humidity = object.humidity ?? 0;
    message.temperature = object.temperature ?? 0;
    message.windSpeed = object.windSpeed ?? 0;
    message.batteryStoreMode = object.batteryStoreMode ?? 0;
    message.alarmState = object.alarmState ?? 0;
    message.putterState = object.putterState ?? 0;
    message.drcState = object.drcState ?? 0;
    message.flighttaskPrepareCapacity = object.flighttaskPrepareCapacity ?? 0;
    message.flighttaskStepCode = object.flighttaskStepCode ?? 0;
    message.subDevice =
      object.subDevice !== undefined && object.subDevice !== null
        ? DockOSD_SubDevice.fromPartial(object.subDevice)
        : undefined;
    message.userExperienceImprovement = object.userExperienceImprovement ?? 0;
    message.jobNumber = object.jobNumber ?? 0;
    message.accTime = object.accTime ?? 0;
    message.activationTime = object.activationTime ?? undefined;
    message.electricSupplyVoltage = object.electricSupplyVoltage ?? 0;
    message.workingVoltage = object.workingVoltage ?? 0;
    message.workingCurrent = object.workingCurrent ?? 0;
    return message;
  },
};

function createBaseDockOSD_NetworkState(): DockOSD_NetworkState {
  return { type: 0, quality: 0, rate: 0 };
}

export const DockOSD_NetworkState: MessageFns<DockOSD_NetworkState> = {
  encode(message: DockOSD_NetworkState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.quality !== 0) {
      writer.uint32(16).int32(message.quality);
    }
    if (message.rate !== 0) {
      writer.uint32(25).double(message.rate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD_NetworkState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD_NetworkState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.quality = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.rate = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD_NetworkState {
    return {
      type: isSet(object.type) ? globalThis.Number(object.type) : 0,
      quality: isSet(object.quality) ? globalThis.Number(object.quality) : 0,
      rate: isSet(object.rate) ? globalThis.Number(object.rate) : 0,
    };
  },

  toJSON(message: DockOSD_NetworkState): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = Math.round(message.type);
    }
    if (message.quality !== 0) {
      obj.quality = Math.round(message.quality);
    }
    if (message.rate !== 0) {
      obj.rate = message.rate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD_NetworkState>, I>>(base?: I): DockOSD_NetworkState {
    return DockOSD_NetworkState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD_NetworkState>, I>>(
    object: I,
  ): DockOSD_NetworkState {
    const message = createBaseDockOSD_NetworkState();
    message.type = object.type ?? 0;
    message.quality = object.quality ?? 0;
    message.rate = object.rate ?? 0;
    return message;
  },
};

function createBaseDockOSD_AlternateLandPoint(): DockOSD_AlternateLandPoint {
  return { longitude: 0, latitude: 0, height: 0, safeLandHeight: 0, isConfigured: false };
}

export const DockOSD_AlternateLandPoint: MessageFns<DockOSD_AlternateLandPoint> = {
  encode(
    message: DockOSD_AlternateLandPoint,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.longitude !== 0) {
      writer.uint32(9).double(message.longitude);
    }
    if (message.latitude !== 0) {
      writer.uint32(17).double(message.latitude);
    }
    if (message.height !== 0) {
      writer.uint32(25).double(message.height);
    }
    if (message.safeLandHeight !== 0) {
      writer.uint32(33).double(message.safeLandHeight);
    }
    if (message.isConfigured !== false) {
      writer.uint32(40).bool(message.isConfigured);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD_AlternateLandPoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD_AlternateLandPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.longitude = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.latitude = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.height = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.safeLandHeight = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isConfigured = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD_AlternateLandPoint {
    return {
      longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
      latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
      safeLandHeight: isSet(object.safeLandHeight) ? globalThis.Number(object.safeLandHeight) : 0,
      isConfigured: isSet(object.isConfigured) ? globalThis.Boolean(object.isConfigured) : false,
    };
  },

  toJSON(message: DockOSD_AlternateLandPoint): unknown {
    const obj: any = {};
    if (message.longitude !== 0) {
      obj.longitude = message.longitude;
    }
    if (message.latitude !== 0) {
      obj.latitude = message.latitude;
    }
    if (message.height !== 0) {
      obj.height = message.height;
    }
    if (message.safeLandHeight !== 0) {
      obj.safeLandHeight = message.safeLandHeight;
    }
    if (message.isConfigured !== false) {
      obj.isConfigured = message.isConfigured;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD_AlternateLandPoint>, I>>(
    base?: I,
  ): DockOSD_AlternateLandPoint {
    return DockOSD_AlternateLandPoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD_AlternateLandPoint>, I>>(
    object: I,
  ): DockOSD_AlternateLandPoint {
    const message = createBaseDockOSD_AlternateLandPoint();
    message.longitude = object.longitude ?? 0;
    message.latitude = object.latitude ?? 0;
    message.height = object.height ?? 0;
    message.safeLandHeight = object.safeLandHeight ?? 0;
    message.isConfigured = object.isConfigured ?? false;
    return message;
  },
};

function createBaseDockOSD_LiveCapacity(): DockOSD_LiveCapacity {
  return { availableVideoNumber: 0, coexistVideoNumberMax: 0 };
}

export const DockOSD_LiveCapacity: MessageFns<DockOSD_LiveCapacity> = {
  encode(message: DockOSD_LiveCapacity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.availableVideoNumber !== 0) {
      writer.uint32(8).int32(message.availableVideoNumber);
    }
    if (message.coexistVideoNumberMax !== 0) {
      writer.uint32(16).int32(message.coexistVideoNumberMax);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD_LiveCapacity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD_LiveCapacity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.availableVideoNumber = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.coexistVideoNumberMax = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD_LiveCapacity {
    return {
      availableVideoNumber: isSet(object.availableVideoNumber)
        ? globalThis.Number(object.availableVideoNumber)
        : 0,
      coexistVideoNumberMax: isSet(object.coexistVideoNumberMax)
        ? globalThis.Number(object.coexistVideoNumberMax)
        : 0,
    };
  },

  toJSON(message: DockOSD_LiveCapacity): unknown {
    const obj: any = {};
    if (message.availableVideoNumber !== 0) {
      obj.availableVideoNumber = Math.round(message.availableVideoNumber);
    }
    if (message.coexistVideoNumberMax !== 0) {
      obj.coexistVideoNumberMax = Math.round(message.coexistVideoNumberMax);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD_LiveCapacity>, I>>(base?: I): DockOSD_LiveCapacity {
    return DockOSD_LiveCapacity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD_LiveCapacity>, I>>(
    object: I,
  ): DockOSD_LiveCapacity {
    const message = createBaseDockOSD_LiveCapacity();
    message.availableVideoNumber = object.availableVideoNumber ?? 0;
    message.coexistVideoNumberMax = object.coexistVideoNumberMax ?? 0;
    return message;
  },
};

function createBaseDockOSD_DockStateData(): DockOSD_DockStateData {
  return {
    firmwareVersion: '',
    firmwareUpgradeStatus: 0,
    compatibleStatus: 0,
    liveCapacity: undefined,
    accTime: 0,
    wpmzVersion: '',
  };
}

export const DockOSD_DockStateData: MessageFns<DockOSD_DockStateData> = {
  encode(message: DockOSD_DockStateData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.firmwareVersion !== '') {
      writer.uint32(10).string(message.firmwareVersion);
    }
    if (message.firmwareUpgradeStatus !== 0) {
      writer.uint32(16).int32(message.firmwareUpgradeStatus);
    }
    if (message.compatibleStatus !== 0) {
      writer.uint32(24).int32(message.compatibleStatus);
    }
    if (message.liveCapacity !== undefined) {
      DockOSD_LiveCapacity.encode(message.liveCapacity, writer.uint32(34).fork()).join();
    }
    if (message.accTime !== 0) {
      writer.uint32(40).int32(message.accTime);
    }
    if (message.wpmzVersion !== '') {
      writer.uint32(50).string(message.wpmzVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD_DockStateData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD_DockStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.firmwareVersion = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.firmwareUpgradeStatus = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.compatibleStatus = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.liveCapacity = DockOSD_LiveCapacity.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.accTime = reader.int32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.wpmzVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD_DockStateData {
    return {
      firmwareVersion: isSet(object.firmwareVersion)
        ? globalThis.String(object.firmwareVersion)
        : '',
      firmwareUpgradeStatus: isSet(object.firmwareUpgradeStatus)
        ? globalThis.Number(object.firmwareUpgradeStatus)
        : 0,
      compatibleStatus: isSet(object.compatibleStatus)
        ? globalThis.Number(object.compatibleStatus)
        : 0,
      liveCapacity: isSet(object.liveCapacity)
        ? DockOSD_LiveCapacity.fromJSON(object.liveCapacity)
        : undefined,
      accTime: isSet(object.accTime) ? globalThis.Number(object.accTime) : 0,
      wpmzVersion: isSet(object.wpmzVersion) ? globalThis.String(object.wpmzVersion) : '',
    };
  },

  toJSON(message: DockOSD_DockStateData): unknown {
    const obj: any = {};
    if (message.firmwareVersion !== '') {
      obj.firmwareVersion = message.firmwareVersion;
    }
    if (message.firmwareUpgradeStatus !== 0) {
      obj.firmwareUpgradeStatus = Math.round(message.firmwareUpgradeStatus);
    }
    if (message.compatibleStatus !== 0) {
      obj.compatibleStatus = Math.round(message.compatibleStatus);
    }
    if (message.liveCapacity !== undefined) {
      obj.liveCapacity = DockOSD_LiveCapacity.toJSON(message.liveCapacity);
    }
    if (message.accTime !== 0) {
      obj.accTime = Math.round(message.accTime);
    }
    if (message.wpmzVersion !== '') {
      obj.wpmzVersion = message.wpmzVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD_DockStateData>, I>>(base?: I): DockOSD_DockStateData {
    return DockOSD_DockStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD_DockStateData>, I>>(
    object: I,
  ): DockOSD_DockStateData {
    const message = createBaseDockOSD_DockStateData();
    message.firmwareVersion = object.firmwareVersion ?? '';
    message.firmwareUpgradeStatus = object.firmwareUpgradeStatus ?? 0;
    message.compatibleStatus = object.compatibleStatus ?? 0;
    message.liveCapacity =
      object.liveCapacity !== undefined && object.liveCapacity !== null
        ? DockOSD_LiveCapacity.fromPartial(object.liveCapacity)
        : undefined;
    message.accTime = object.accTime ?? 0;
    message.wpmzVersion = object.wpmzVersion ?? '';
    return message;
  },
};

function createBaseDockOSD_SubDevice(): DockOSD_SubDevice {
  return { deviceSn: '', deviceModelKey: '', deviceOnlineStatus: 0, devicePaired: 0 };
}

export const DockOSD_SubDevice: MessageFns<DockOSD_SubDevice> = {
  encode(message: DockOSD_SubDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceSn !== '') {
      writer.uint32(10).string(message.deviceSn);
    }
    if (message.deviceModelKey !== '') {
      writer.uint32(18).string(message.deviceModelKey);
    }
    if (message.deviceOnlineStatus !== 0) {
      writer.uint32(24).int32(message.deviceOnlineStatus);
    }
    if (message.devicePaired !== 0) {
      writer.uint32(32).int32(message.devicePaired);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD_SubDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD_SubDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceSn = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceModelKey = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.deviceOnlineStatus = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.devicePaired = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD_SubDevice {
    return {
      deviceSn: isSet(object.deviceSn) ? globalThis.String(object.deviceSn) : '',
      deviceModelKey: isSet(object.deviceModelKey) ? globalThis.String(object.deviceModelKey) : '',
      deviceOnlineStatus: isSet(object.deviceOnlineStatus)
        ? globalThis.Number(object.deviceOnlineStatus)
        : 0,
      devicePaired: isSet(object.devicePaired) ? globalThis.Number(object.devicePaired) : 0,
    };
  },

  toJSON(message: DockOSD_SubDevice): unknown {
    const obj: any = {};
    if (message.deviceSn !== '') {
      obj.deviceSn = message.deviceSn;
    }
    if (message.deviceModelKey !== '') {
      obj.deviceModelKey = message.deviceModelKey;
    }
    if (message.deviceOnlineStatus !== 0) {
      obj.deviceOnlineStatus = Math.round(message.deviceOnlineStatus);
    }
    if (message.devicePaired !== 0) {
      obj.devicePaired = Math.round(message.devicePaired);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD_SubDevice>, I>>(base?: I): DockOSD_SubDevice {
    return DockOSD_SubDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD_SubDevice>, I>>(object: I): DockOSD_SubDevice {
    const message = createBaseDockOSD_SubDevice();
    message.deviceSn = object.deviceSn ?? '';
    message.deviceModelKey = object.deviceModelKey ?? '';
    message.deviceOnlineStatus = object.deviceOnlineStatus ?? 0;
    message.devicePaired = object.devicePaired ?? 0;
    return message;
  },
};

function createBaseDockOSD_ObstacleSensing(): DockOSD_ObstacleSensing {
  return {
    upDistance: 0,
    downDistance: 0,
    upEnable: false,
    upWork: false,
    downEnable: false,
    downWork: false,
    leftEnable: false,
    leftWork: false,
    rightEnable: false,
    rightWork: false,
    frontEnable: false,
    frontWork: false,
    backEnable: false,
    backWork: false,
    verticalEnable: false,
    verticalWork: false,
    horizontalEnable: false,
    horizontalWork: false,
    aroundDistance: [],
  };
}

export const DockOSD_ObstacleSensing: MessageFns<DockOSD_ObstacleSensing> = {
  encode(
    message: DockOSD_ObstacleSensing,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.upDistance !== 0) {
      writer.uint32(16).int64(message.upDistance);
    }
    if (message.downDistance !== 0) {
      writer.uint32(24).int64(message.downDistance);
    }
    if (message.upEnable !== false) {
      writer.uint32(32).bool(message.upEnable);
    }
    if (message.upWork !== false) {
      writer.uint32(40).bool(message.upWork);
    }
    if (message.downEnable !== false) {
      writer.uint32(48).bool(message.downEnable);
    }
    if (message.downWork !== false) {
      writer.uint32(56).bool(message.downWork);
    }
    if (message.leftEnable !== false) {
      writer.uint32(64).bool(message.leftEnable);
    }
    if (message.leftWork !== false) {
      writer.uint32(72).bool(message.leftWork);
    }
    if (message.rightEnable !== false) {
      writer.uint32(80).bool(message.rightEnable);
    }
    if (message.rightWork !== false) {
      writer.uint32(88).bool(message.rightWork);
    }
    if (message.frontEnable !== false) {
      writer.uint32(96).bool(message.frontEnable);
    }
    if (message.frontWork !== false) {
      writer.uint32(104).bool(message.frontWork);
    }
    if (message.backEnable !== false) {
      writer.uint32(112).bool(message.backEnable);
    }
    if (message.backWork !== false) {
      writer.uint32(120).bool(message.backWork);
    }
    if (message.verticalEnable !== false) {
      writer.uint32(128).bool(message.verticalEnable);
    }
    if (message.verticalWork !== false) {
      writer.uint32(136).bool(message.verticalWork);
    }
    if (message.horizontalEnable !== false) {
      writer.uint32(144).bool(message.horizontalEnable);
    }
    if (message.horizontalWork !== false) {
      writer.uint32(152).bool(message.horizontalWork);
    }
    writer.uint32(162).fork();
    for (const v of message.aroundDistance) {
      writer.int64(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DockOSD_ObstacleSensing {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockOSD_ObstacleSensing();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.upDistance = longToNumber(reader.int64());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.downDistance = longToNumber(reader.int64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.upEnable = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.upWork = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.downEnable = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.downWork = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.leftEnable = reader.bool();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.leftWork = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.rightEnable = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.rightWork = reader.bool();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.frontEnable = reader.bool();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.frontWork = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.backEnable = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.backWork = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.verticalEnable = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.verticalWork = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.horizontalEnable = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.horizontalWork = reader.bool();
          continue;
        }
        case 20: {
          if (tag === 160) {
            message.aroundDistance.push(longToNumber(reader.int64()));

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.aroundDistance.push(longToNumber(reader.int64()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockOSD_ObstacleSensing {
    return {
      upDistance: isSet(object.upDistance) ? globalThis.Number(object.upDistance) : 0,
      downDistance: isSet(object.downDistance) ? globalThis.Number(object.downDistance) : 0,
      upEnable: isSet(object.upEnable) ? globalThis.Boolean(object.upEnable) : false,
      upWork: isSet(object.upWork) ? globalThis.Boolean(object.upWork) : false,
      downEnable: isSet(object.downEnable) ? globalThis.Boolean(object.downEnable) : false,
      downWork: isSet(object.downWork) ? globalThis.Boolean(object.downWork) : false,
      leftEnable: isSet(object.leftEnable) ? globalThis.Boolean(object.leftEnable) : false,
      leftWork: isSet(object.leftWork) ? globalThis.Boolean(object.leftWork) : false,
      rightEnable: isSet(object.rightEnable) ? globalThis.Boolean(object.rightEnable) : false,
      rightWork: isSet(object.rightWork) ? globalThis.Boolean(object.rightWork) : false,
      frontEnable: isSet(object.frontEnable) ? globalThis.Boolean(object.frontEnable) : false,
      frontWork: isSet(object.frontWork) ? globalThis.Boolean(object.frontWork) : false,
      backEnable: isSet(object.backEnable) ? globalThis.Boolean(object.backEnable) : false,
      backWork: isSet(object.backWork) ? globalThis.Boolean(object.backWork) : false,
      verticalEnable: isSet(object.verticalEnable)
        ? globalThis.Boolean(object.verticalEnable)
        : false,
      verticalWork: isSet(object.verticalWork) ? globalThis.Boolean(object.verticalWork) : false,
      horizontalEnable: isSet(object.horizontalEnable)
        ? globalThis.Boolean(object.horizontalEnable)
        : false,
      horizontalWork: isSet(object.horizontalWork)
        ? globalThis.Boolean(object.horizontalWork)
        : false,
      aroundDistance: globalThis.Array.isArray(object?.aroundDistance)
        ? object.aroundDistance.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: DockOSD_ObstacleSensing): unknown {
    const obj: any = {};
    if (message.upDistance !== 0) {
      obj.upDistance = Math.round(message.upDistance);
    }
    if (message.downDistance !== 0) {
      obj.downDistance = Math.round(message.downDistance);
    }
    if (message.upEnable !== false) {
      obj.upEnable = message.upEnable;
    }
    if (message.upWork !== false) {
      obj.upWork = message.upWork;
    }
    if (message.downEnable !== false) {
      obj.downEnable = message.downEnable;
    }
    if (message.downWork !== false) {
      obj.downWork = message.downWork;
    }
    if (message.leftEnable !== false) {
      obj.leftEnable = message.leftEnable;
    }
    if (message.leftWork !== false) {
      obj.leftWork = message.leftWork;
    }
    if (message.rightEnable !== false) {
      obj.rightEnable = message.rightEnable;
    }
    if (message.rightWork !== false) {
      obj.rightWork = message.rightWork;
    }
    if (message.frontEnable !== false) {
      obj.frontEnable = message.frontEnable;
    }
    if (message.frontWork !== false) {
      obj.frontWork = message.frontWork;
    }
    if (message.backEnable !== false) {
      obj.backEnable = message.backEnable;
    }
    if (message.backWork !== false) {
      obj.backWork = message.backWork;
    }
    if (message.verticalEnable !== false) {
      obj.verticalEnable = message.verticalEnable;
    }
    if (message.verticalWork !== false) {
      obj.verticalWork = message.verticalWork;
    }
    if (message.horizontalEnable !== false) {
      obj.horizontalEnable = message.horizontalEnable;
    }
    if (message.horizontalWork !== false) {
      obj.horizontalWork = message.horizontalWork;
    }
    if (message.aroundDistance?.length) {
      obj.aroundDistance = message.aroundDistance.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockOSD_ObstacleSensing>, I>>(
    base?: I,
  ): DockOSD_ObstacleSensing {
    return DockOSD_ObstacleSensing.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockOSD_ObstacleSensing>, I>>(
    object: I,
  ): DockOSD_ObstacleSensing {
    const message = createBaseDockOSD_ObstacleSensing();
    message.upDistance = object.upDistance ?? 0;
    message.downDistance = object.downDistance ?? 0;
    message.upEnable = object.upEnable ?? false;
    message.upWork = object.upWork ?? false;
    message.downEnable = object.downEnable ?? false;
    message.downWork = object.downWork ?? false;
    message.leftEnable = object.leftEnable ?? false;
    message.leftWork = object.leftWork ?? false;
    message.rightEnable = object.rightEnable ?? false;
    message.rightWork = object.rightWork ?? false;
    message.frontEnable = object.frontEnable ?? false;
    message.frontWork = object.frontWork ?? false;
    message.backEnable = object.backEnable ?? false;
    message.backWork = object.backWork ?? false;
    message.verticalEnable = object.verticalEnable ?? false;
    message.verticalWork = object.verticalWork ?? false;
    message.horizontalEnable = object.horizontalEnable ?? false;
    message.horizontalWork = object.horizontalWork ?? false;
    message.aroundDistance = object.aroundDistance?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
  ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === 'string') {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER');
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error('Value is smaller than Number.MIN_SAFE_INTEGER');
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
